import {
  CREATE_PIRING_BERBAGI_SUCCESS,
  CREATE_PIRING_BERBAGI_FAIL,
  RETRIEVE_PIRING_BERBAGI_SUCCESS,
  RETRIEVE_PIRING_BERBAGI_FAIL,
  UPDATE_PIRING_BERBAGI_SUCCESS,
  UPDATE_PIRING_BERBAGI_FAIL,
  DELETE_PIRING_BERBAGI_SUCCESS,
  DELETE_PIRING_BERBAGI_FAIL,
} from "../actions/types";

const initialState = {
  items: [],
  totalPages: 0,
  currentPage: 1,
  totalItems: 0,
};

function Reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_PIRING_BERBAGI_SUCCESS:
      return { ...state, items: [...state.items, payload] };

    case RETRIEVE_PIRING_BERBAGI_SUCCESS:
      return {
        items: payload.data,
        totalPages: payload.totalPages,
        currentPage: payload.currentPage,
        totalItems: payload.totalItems,
      };

    case RETRIEVE_PIRING_BERBAGI_FAIL:
      return { ...state };

    case UPDATE_PIRING_BERBAGI_SUCCESS:
      return {
        ...state,
        items: state.items.map((data) => {
          if (data.uuid === payload.uuid) {
            return {
              ...data,
              ...payload,
            };
          } else {
            return data;
          }
        }),
      };

    case DELETE_PIRING_BERBAGI_SUCCESS:
      return {
        ...state,
        items: state.items.filter(({ uuid }) => uuid !== payload.uuid),
      };

    default:
      return state;
  }
}

export default Reducer;
